import { html, LitElement } from 'lit';
import { FsIcon } from '@cof/fs-icon-wc/fs-icon.js';
import { fs24Calendar } from '@cof/fs-icons';
import { style } from './iconic-offer-card-details.style.js';
import { gravityGrid, gravityTypography, gravityContainer, gravitySpacing } from '../../shared/styles/gravity.style.js';

FsIcon.add(fs24Calendar);

class RefiIconicOfferCardDetails extends LitElement {
  static get properties() {
    return {
      monthlyPayment: { type: String, attribute: 'monthly-payment' },
      offerApr: { type: String, attribute: 'offer-apr' },
      term: { type: String, attribute: true },
      currentLoanTerm: { type: Number, attribute: 'current-loan-term' },
      testLayout: { type: Boolean, attribute: 'test-layout' },
      payment_size: { type: String, attribute: 'payment-size' },
      gap_class: { type: String, attribute: 'gap-class' },
    };
  }

  static get styles() {
    return [gravityGrid, gravityTypography, gravityContainer, gravitySpacing, style];
  }

  constructor() {
    super();
    this.currentLoanTerm = 0;
    this.payment_size = null;
    this.gap_class = '';
  }

  render() {
    return html`
      <div class="grv-grid">
        <div class="grv-row ${this.gap_class} justify-between">
          <div class="card-column">
            <p class="_gb-show grv-text--small-1 grv-weight--normal ">Monthly payment</p>
            ${this.payment_size !== null
              ? html` <p class="_gb-show ${this.payment_size} grv-weight--semibold">$${Math.round(this.monthlyPayment)}</p>`
              : html` <p class="_gb-show grv-text--large-1 grv-weight--semibold">$${Math.round(this.monthlyPayment)}</p>`}
          </div>
          <div class="card-column apr-column">
            ${this.offerApr
              ? html`
                  <p class="_gb-show grv-text--small-1 grv-weight--normal">APR</p>
                  <p class="_gb-show grv-text--medium-2 grv-weight--semibold">${this.apr}%</p>
                `
              : ''}
          </div>
          <div class="card-column term-column">
            <p class="_gb-show grv-text--small-1 grv-weight--normal">Term (months)</p>
            <p class="_gb-show grv-text--medium-2 grv-weight--semibold">${this.term}</p>
          </div>
        </div>
      </div>
    `;
  }

  get apr() {
    return Number.parseFloat(this.offerApr).toFixed(2);
  }
}

customElements.define('refi-iconic-offer-card-details', RefiIconicOfferCardDetails);
